import { Box, CircularProgress, Typography } from "@mui/material";

export function LoadingScreen({
  message = "Loading...",
}: {
  message?: string;
}) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
      sx={{ minHeight: "calc(100vh - 278px)", width: "100%" }}
    >
      <CircularProgress />
      <Typography variant="body1" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
}

export default LoadingScreen;
